import { XMarkIcon as XIcon } from "@heroicons/react/24/outline";
import {
  Cog6ToothIcon,
  TableCellsIcon as ViewGridIcon,
  QueueListIcon as ViewListIcon,
} from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";

import React, { useState } from "react";
import { portfolioConfig } from "../config/portfolio.config";

const Profile = () => {
  const [viewMode, setViewMode] = useState("grid");
  const [selectedPost, setSelectedPost] = useState(null);

  const openPost = (post) => {
    setSelectedPost(post);
  };

  const closePost = () => {
    setSelectedPost(null);
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Profile Header */}
      <div className="flex flex-col items-center py-8 md:flex-row md:items-start">
        <img
          src={portfolioConfig.avatar}
          alt={portfolioConfig.name}
          className="object-cover w-32 h-32 mb-4 rounded-full md:mb-0 md:mr-8"
        />
        <div>
          <div className="flex items-center mb-4">
            <h1 className="mr-4 text-2xl font-semibold">
              {portfolioConfig.username}
            </h1>
            <button className="px-4 py-1 text-sm font-semibold text-white bg-blue-500 rounded-md">
              Edit Profile
            </button>
            <Link to="/settings" className="px-2">
              <Cog6ToothIcon className="w-6 h-6 text-gray-500" />
            </Link>
          </div>
          <div className="flex mb-4 space-x-4">
            <span>
              <strong>{portfolioConfig.posts.length}</strong> posts
            </span>
            <span>
              <strong>1.2k</strong> followers
            </span>
            <span>
              <strong>500</strong> following
            </span>
          </div>
          <h2 className="font-semibold">{portfolioConfig.name}</h2>
          <p>{portfolioConfig.bio}</p>
        </div>
      </div>

      {/* View Toggle */}
      <div className="flex justify-center mb-4">
        <button
          className={`p-2 ${
            viewMode === "grid" ? "bg-gray-200 dark:bg-gray-800" : ""
          }`}
          onClick={() => setViewMode("grid")}
        >
          <ViewGridIcon className="w-6 h-6" />
        </button>
        <button
          className={`p-2 ${
            viewMode === "list" ? "bg-gray-200 dark:bg-gray-800" : ""
          }`}
          onClick={() => setViewMode("list")}
        >
          <ViewListIcon className="w-6 h-6" />
        </button>
      </div>

      {/* Posts */}
      {viewMode === "grid" ? (
        <div className="grid grid-cols-3 gap-1">
          {portfolioConfig.posts.map((post) => (
            <img
              key={post.id}
              src={post.image}
              alt={post.caption}
              className="object-cover w-full h-40 cursor-pointer"
              onClick={() => openPost(post)}
            />
          ))}
        </div>
      ) : (
        <div className="space-y-4">
          {portfolioConfig.posts.map((post) => (
            <div key={post.id} className="bg-white rounded-lg shadow">
              <img
                key={post.id}
                src={post.image}
                alt={post.caption}
                className="object-cover w-full h-64 rounded-t-lg"
              />
              <div className="p-4">
                <p>{post.caption}</p>
                <p className="mt-2 text-gray-500">
                  {post.likes} likes • {post.comments.length} comments
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Post Modal */}
      {selectedPost && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <div className="w-full max-w-3xl bg-white rounded-lg">
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="font-semibold">{portfolioConfig.username}</h2>
              <button onClick={closePost}>
                <XIcon className="w-6 h-6" />
              </button>
            </div>
            <img
              src={selectedPost.image}
              alt={selectedPost.caption}
              className="object-cover w-full h-96"
            />
            <div className="p-4">
              <p>{selectedPost.caption}</p>
              <p className="mt-2 text-gray-500">
                {selectedPost.likes} likes • {selectedPost.comments} comments
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
